export default __webpack_public_path__ + "static/media/mars18.5fd71db9.gif";